import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSignOutAlt } from 'react-icons/fa'; 
import logo from '../img/logo.png'; 
import { FaUserCircle } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";

import './css/Header.css'

const Header = () => {
  
  const [showConfirmation, setShowConfirmation] = useState(false);
  const navigate = useNavigate();
  const userName = localStorage.getItem("user_name");
  let instituicao = localStorage.getItem("instituicao");

  const handleLogout = async () => {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/logout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include'
    });

    if (response.ok) {
      localStorage.removeItem("user_name");

      navigate("/");
    } else {
      alert("Erro ao tentar deslogar!");
    }
  };

  return (
    <header className="header-content">
      <div className="logo" onClick={() => navigate("/emitir-certificado")}>
        <img src={logo} alt="Logo" />
      </div>
      
      <div className="user-info">
        <FaUserCircle className='logo-user' />
        <div className='info-user'>
          <p>{userName ? `${userName}` : "Bem-vindo!"}</p>
          <span>{instituicao}</span>
        </div>
        <div className='logout-container'>
          <button className="logout-btn" onClick={() => setShowConfirmation(true)}>
            <IoIosArrowDown />
          </button>
        </div>
      </div>

      {/* Card de Confirmação de Logout */}
      {showConfirmation && (
        <div className="confirmation-card">
          <p>Deseja encerrar sessão?</p>
          <button onClick={handleLogout}>Sim</button>
          <button onClick={() => setShowConfirmation(false)}>Cancelar</button>
        </div>
      )}
    </header>
  );
};

export default Header;
